import { actions } from './actions'

const initialState = {
  articulos: {
    data: [],
    loading: false,
    error: '',
  },
  articulo: {
    data: null,
    loading: false,
    error: '',
  },
  articulosProductos: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  articulosStock: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  articulosVendidos: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
}

export default function articulosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ARTICULOS_LOAD_REQUESTED:
      return { ...state, articulos: { ...state.articulos, data: null, loading: true } }
    case actions.ARTICULOS_LOAD_SUCCEEDED:
      return {
        ...state,
        articulos: { ...state.articulos, data: action.payload, loading: false, reload: false },
      }
    case actions.ARTICULOS_LOAD_FILED:
      return {
        ...state,
        articulos: { ...state.articulos, loading: false, error: action.error },
      }
    case actions.ARTICULOS_FALTANTES_LOAD_REQUESTED:
      return { ...state, articulos: { ...state.articulos, data: null, loading: true } }
    case actions.ARTICULOS_FALTANTES_LOAD_SUCCEEDED:
      return {
        ...state,
        articulos: { ...state.articulos, data: action.payload, loading: false, reload: false },
      }
    case actions.ARTICULOS_FALTANTES_LOAD_FILED:
      return {
        ...state,
        articulos: { ...state.articulos, loading: false, error: action.error },
      }
    case actions.ARTICULOS_FILTERED_LOAD_REQUESTED:
      return { ...state, articulos: { ...state.articulos, data: null, loading: true } }
    case actions.ARTICULOS_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        articulos: { ...state.articulos, data: action.payload, loading: false },
      }
    case actions.ARTICULOS_FILTERED_LOAD_FILED:
      return {
        ...state,
        articulos: { ...state.articulos, loading: false, error: action.error },
      }
    case actions.ARTICULO_DELETE_REQUESTED:
      return {
        ...state,
        articulos: { ...state.articulos, loading: true, error: '' },
      }
    case actions.ARTICULO_DELETE_SUCCEEDED:
      return {
        ...state,
        articulos: {
          ...state.articulos,
          data: state.articulos.data.filter(articulo => articulo.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ARTICULO_DELETE_FILED:
      return {
        ...state,
        articulos: { ...state.articulos, loading: false, error: action.error },
      }
    case actions.ARTICULO_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        articulo: { ...state.articulo, data: null, loading: false, error: '' },
      }
    case actions.ARTICULO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        articulo: { ...state.articulo, loading: true, error: '' },
      }
    case actions.ARTICULO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        articulo: { ...state.articulo, data: action.payload, loading: false, error: '' },
      }
    case actions.ARTICULO_BYID_LOAD_FILED:
      return {
        ...state,
        articulo: { ...state.articulo, data: null, loading: false, error: action.error },
      }
    case actions.ARTICULO_UPDATE_REQUESTED:
      return {
        ...state,
        articulo: { ...state.articulo, loading: true, error: '' },
      }
    case actions.ARTICULO_UPDATE_SUCCEEDED:
      return {
        ...state,
        articulo: { ...state.articulo, data: action.payload, loading: false, error: '' },
      }
    case actions.ARTICULO_UPDATE_FILED:
      return {
        ...state,
        articulo: { ...state.articulo, loading: false, error: action.error },
      }
    case actions.ARTICULO_INSERT_REQUESTED:
      return {
        ...state,
        articulo: { ...state.articulo, loading: true, error: '' },
      }
    case actions.ARTICULO_INSERT_SUCCEEDED:
      return {
        ...state,
        articulo: { ...state.articulo, data: action.payload, loading: false, error: '' },
      }
    case actions.ARTICULO_INSERT_FILED:
      return {
        ...state,
        articulo: { ...state.articulo, loading: false, error: action.error },
      }
    case actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_REQUESTED:
      return { ...state, articulosProductos: { ...state.articulosProductos, loading: true } }
    case actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_SUCCEEDED:
      return {
        ...state,
        articulosProductos: { ...state.articulosProductos, data: action.payload, loading: false },
      }
    case actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_FILED:
      return {
        ...state,
        articulosProductos: { ...state.articulosProductos, loading: false, error: action.error },
      }
    case actions.ARTICULO_PRODUCTO_DELETE_REQUESTED:
      return {
        ...state,
        articulosProductos: { ...state.articulosProductos, loading: true, error: '' },
      }
    case actions.ARTICULO_PRODUCTO_DELETE_SUCCEEDED:
      return {
        ...state,
        articulosProductos: {
          ...state.articulosProductos,
          data: state.articulosProductos.data.filter(articulo => articulo.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ARTICULO_PRODUCTO_DELETE_FILED:
      return {
        ...state,
        articulosProductos: { ...state.articulosProductos, loading: false, error: action.error },
      }

    case actions.ARTICULOS_PRODUCTOS_INSERT_REQUESTED:
      return { ...state, articulosProductos: { ...state.articulosProductos, loading: true } }
    case actions.ARTICULOS_PRODUCTOS_INSERT_SUCCEEDED:
      return {
        ...state,
        articulosProductos: { ...state.articulosProductos, loading: false, reload: true },
      }
    case actions.ARTICULOS_PRODUCTOS_INSERT_FILED:
      return {
        ...state,
        articulosProductos: { ...state.articulosProductos, loading: false, error: action.error },
      }
    case actions.ARTICULO_STOCK_UPDATE_REQUESTED:
      return {
        ...state,
        articulosStock: { ...state.articulosStock, loading: true, error: '' },
      }
    case actions.ARTICULO_STOCK_UPDATE_SUCCEEDED:
      return {
        ...state,
        articulosStock: { ...state.articulosStock, data: [], loading: false, error: '' },
      }
    case actions.ARTICULO_STOCK_UPDATE_FAILED:
      return {
        ...state,
        articulosStock: { ...state.articulosStock, loading: false, error: action.error },
      }
    case actions.ARTICULOS_VENDIDOS_LOAD_REQUESTED:
      return {
        ...state,
        articulosVendidos: { ...state.articulosVendidos, loading: true, error: '' },
      }
    case actions.ARTICULOS_VENDIDOS_LOAD_SUCCEEDED:
      return {
        ...state,
        articulosVendidos: {
          ...state.articulosVendidos,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.ARTICULOS_VENDIDOS_LOAD_FAILED:
      return {
        ...state,
        articulosVendidos: { ...state.articulosVendidos, loading: false, error: action.error },
      }
    default:
      return state
  }
}
